import { render, staticRenderFns } from "./analysisDetail.vue?vue&type=template&id=2465f6cc&scoped=true&"
import script from "./analysisDetail.vue?vue&type=script&lang=js&"
export * from "./analysisDetail.vue?vue&type=script&lang=js&"
import style0 from "./analysisDetail.vue?vue&type=style&index=0&id=2465f6cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2465f6cc",
  null
  
)

component.options.__file = "analysisDetail.vue"
export default component.exports